import { styled } from "@mui/system";

export const StyledHeaderBtnGroup = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "0.5rem",
  left: 0,
  flexWrap: "nowrap",
  marginTop: "21px",
  justifyContent: "center",
  [theme.breakpoints.up("sm")]: {
    justifyContent: "flex-end",
    gap: "1rem"
  }
}));
